export namespace navBarType {
  export const enum NavBar {
    Top = '/',
    Lend = '/lend',
    Return = '/return',
    Bibliographies = '/bibliographies',
    User = '/user',
    Reference = '/reference'
  }

  // eslint-disable-next-line no-inner-declarations
  export function getNavBar(value: string): navBarType.NavBar {
    switch (value) {
      case NavBar.Top:
        return NavBar.Top
      case NavBar.Lend:
        return NavBar.Lend
      case NavBar.Return:
        return NavBar.Return
      case NavBar.Bibliographies:
        return NavBar.Bibliographies
      case NavBar.User:
        return NavBar.User
      case NavBar.Reference:
        return NavBar.Reference
    }

    return NavBar.Top
  }

  export interface INavBarItem {
    text: string
    path: string
    functionKey: string
    icon: string
  }
}
